import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=ed51b1e6&scoped=true"
import script from "./qr-code.vue?vue&type=script&lang=js"
export * from "./qr-code.vue?vue&type=script&lang=js"
import style0 from "./qr-code.vue?vue&type=style&index=0&id=ed51b1e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed51b1e6",
  null
  
)

export default component.exports